import { Component, Input, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { Router } from '@angular/router';
import { ScreenService } from '../../services/screen/screen.service';
import { BreadcrumbModule } from 'primeng/breadcrumb';

const NG_MODULES = [CommonModule, RouterModule];
const PRIME_MODULES = [BreadcrumbModule];
@Component({
  selector: 'app-page-header',
  standalone: true,
  imports: [NG_MODULES, PRIME_MODULES],
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss'],
})
export class PageHeaderComponent {
  @Input() class!: string;
  @Input() totalRegistros!: number;
  @Input() categoryLabel: string | null = null;
  @Input() textToSearch = '';
  @Input() isLoading: boolean = false;

  // Signals reactivos desde ScreenService
  readonly isMobile = this.screenService.isMobile;

  readonly fontSize = computed(() => (this.isMobile() ? '15px' : '18px'));

  // Computed signals para lógica de visualización
  readonly isProductOrContactPage = computed(() => {
    const url = this.router.url;
    return (
      url.includes('/inicio/productos/ficha/') ||
      url.includes('/sitio/contacto')
    );
  });

  readonly containerClasses = computed(() => ({
    titleBusqueda: !this.isProductOrContactPage(),
  }));

  constructor(private router: Router, private screenService: ScreenService) {}

  /**
   * Decodifica una cadena URL
   */
  decodedUrl(cadena: string): string {
    return decodeURIComponent(cadena);
  }

  /**
   * Extrae el nombre de la marca de la URL actual.
   * - Aparece cuando se filtra por marca en la búsqueda.
   */
  getBrandNameFromUrl(): string {
    try {
      const currentUrl = this.router.url;
      const urlParams = new URLSearchParams(currentUrl.split('?')[1]);
      const brandParam = urlParams.get('_MARCA') || '';
      return brandParam;
    } catch {
      // Fallback al método anterior si falla el parsing
      const currentUrl = this.router.url;
      return currentUrl.includes('=')
        ? currentUrl.split('=')[1]?.split('&')[0] || ''
        : '';
    }
  }

  /**
   * Verifica si la URL contiene información de marca
   */
  isBrandSearch(): boolean {
    return this.router.url.includes('_MARCA');
  }
}
